import Alpine from 'alpinejs';
import headerScroll from './header-scroll';

window.Alpine = Alpine;

window.headerScroll = headerScroll;

Alpine.start();
